import { render, staticRenderFns } from "./ProductExchangeDetails.vue?vue&type=template&id=fe4297ae&"
import script from "./ProductExchangeDetails.vue?vue&type=script&lang=ts&"
export * from "./ProductExchangeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports